import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

export default createAPIRequestReducer(ActionTypes.PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD)
